import { TestResultDto } from '../dto/hardware-test-result.dto'
import { HardwareTestResultModel } from '../models'

const fromDtoToTestResultModelTransformer = (dto: TestResultDto): HardwareTestResultModel => ({
  testId: dto.testId || undefined,
  testRunId: dto.testRunId || undefined,
  availableTests: dto.availableTests?.filter(elem => !!elem) || [],
  message: {
    key: dto.message?.key ?? '',
    alternativeText: dto.message?.alternativeText ?? '',
    params: dto.message?.params ?? {},
  },
  state: dto.state,
})

export default fromDtoToTestResultModelTransformer
